// @flow
/**
 * Format Currency - (CURRENCY) Number
 * @param {number|string} value
 * @param {string} locale
 * 1000.25 or '1000.25' to 'R$1.000,25'
 * @returns {string} With currency and formatted number
 */
export default function currencyFormat(value: number | string, locale: string = 'pt-BR'): string {
  if (!value && value !== 0) { return ''; }

  return parseFloat(value).toLocaleString(locale, { style: 'currency', currency: 'BRL' });
}
